module.exports = __webpack_public_path__ + "static/hospitality-6f02e81d8788e78e70e936d6109cc8d8.jpg";